import React from "react";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import WebView from "react-native-webview";

export function SupportTeamSchedule() {
  const insets = useSafeAreaInsets();
  if (Platform.OS === "web") {
    return (
      <iframe
        src="https://www.storesprint.com/support/direct/team-schedule-find-create"
        style={{ width: "100%", height: "100%" }}
      />
    );
  }
  return (
    <WebView
      allowsFullscreenVideo
      allowsInlineMediaPlayback
      source={{
        uri: `https://www.storesprint.com/support/direct/team-schedule-find-create`,
      }}
      automaticallyAdjustContentInsets
      automaticallyAdjustsScrollIndicatorInsets
      decelerationRate={Platform.OS === "ios" ? "normal" : undefined}
      containerStyle={{
        paddingBottom: Platform.OS === "ios" ? insets.bottom : 0,
      }}
    />
  );
}
